<style>
</style>

<template>
<basic-layout>
  <md-empty-state
      class="md-accent"
      md-rounded="true"
      md-icon="warning"
      md-label="You are lost."
      md-description="This page doesn't exist.">

      <md-button to="/" class="md-primary">Take me home.</md-button>
  </md-empty-state>
</basic-layout>
</template>

<script>
import BasicLayout from '@/components/layouts/basic'
export default {
  name: 'NotFound',
  components: { BasicLayout }
}
</script>
